$shm_hitalama_text_embed_image $shm_media
	Preview_image $mol_image
		uri <= uri
		title <= title
	Full_image $mol_image
		uri <= uri
		title <= title
